<div *ngIf="scenarios.length === 0">No scenarios have been uploaded.</div>
<ng-container *ngIf="scenarios.length > 0">
  <div *ngFor="let scenario of scenarios; index as i" class="basin-display-flex basin-justify-content-space-between basin-align-items-center" [class.basin-mt-2]="i > 0">
    <div class="basin-display-flex basin-align-items-center">
      <p-inputSwitch [name]="'Scenario ' + scenario.name" [(ngModel)]="scenario.visible" (onChange)="scenariosChange()"></p-inputSwitch>
      <label [for]="'Scenario ' + scenario.name" class="basin-ml-1" style="margin-bottom: 1px">{{ 'Scenario ' + scenario.name }}</label>
    </div>
  </div>
</ng-container>
